import React, { useState, useEffect } from 'react';
import Header from '../Header';
import Menu from '../Menu';
import 'jquery/dist/jquery.min.js';

// DataTable Modules
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-buttons/js/dataTables.buttons.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.flash.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';

import $ from 'jquery';
import axios from 'axios';

const CounsellingStudents = () => {
  const [data, setData] = useState([]);

  const fetchData = () => {
    axios.get('/counselling/student-data')
      .then(res => {
        setData(res.data.data);
        setTimeout(() => {
          $('#example').DataTable({
            destroy: true, // helps if reinitializing
            pagingType: 'full_numbers',
            pageLength: 15,
            processing: true,
            dom: 'Bfrtip',
            buttons: ['copy', 'csv', 'print', 'excelHtml5', 'pdf']
          });
        }, 200);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="container p-5">
          <table id="example" className="table table-hover table-bordered">
            <thead>
              <tr>
                <th>Sl.No</th>
                <th>Application No</th>
                <th>Student Name</th>
                <th>Father's Name</th>
                <th>Mobile No</th>
                <th>Email-ID</th>
                <th>State</th>
                <th>Obtain Marks</th>
                <th>Program</th>
                <th>Rank</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data && data.map((result, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{result.application_no}</td>
                  <td>{result.user.name}</td>
                  <td>{result.personal_details.fatherName}</td>
                  <td>{result.user.mobileNo}</td>
                  <td>{result.user.email}</td>
                  <td>{result.personal_details.state}</td>
                  <td>{result.obtained_marks}</td>
                  <td>{result.user.program}</td>
                  <td>{result.rank}</td>
                  <td>
                    <button style={{ backgroundColor: '#007bff', color: 'white', borderRadius: '20%', border: '#007bff' }}>
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CounsellingStudents;
